import { Component, EventEmitter, inject, Input, Output } from "@angular/core";
import { environment } from "src/environments/environment";
import { TableColumn } from "src/app/services/model/tables.model";
import { FormGroup } from "@angular/forms";
import { CoursePricing, resolveCoursePricing } from "src/utils/course-pricing";

@Component({
  selector: "app-course-table-widget",
  templateUrl: "./course-table-widget.component.html",
  styleUrl: "./course-table-widget.component.scss",
  standalone: false,
})
export class CourseTableWidgetComponent {
  /**
   * Price for a row, through the same rule the detail page uses — a discount
   * counts only while `expire_discount_date` is in the future, and the struck
   * original is shown beside it. Reused rather than re-derived so the list and
   * the page a click later can never disagree about what a course costs.
   */
  pricing(row: any): CoursePricing {
    return resolveCoursePricing(row);
  }

  @Input() showCardHeader: boolean = false;
  @Input() tableLabel: string = "APP.ITEMS";
  @Input() buttonLabel: string = "APP.ADD";
  @Input() showCardSpace: boolean = true;
  @Input() showHoverBg: boolean = true;
  @Input() rowClick: boolean = true;
  @Input() rowBorderBottom: boolean = true;
  @Input() scrollToTop: boolean = false;

  @Input()
  set dataSource(value: any) {
    if (value) {
      this.sources = value;
    }
  }

  @Input() dataColumns: TableColumn[] = [];

  @Input() set isLoading(value: boolean) {
    this.loading = value;

    if (!this.loading && this.scrollToTop) {
      const element = document.getElementById("table_header");
      if (element) {
        element.scrollIntoView({ behavior: "smooth" }); // scroll smoothly to the element
      }
    }
  }
  @Output() onRowClick = new EventEmitter();
  @Output() onButtonClick = new EventEmitter();
  @Output() tableChange = new EventEmitter();

  loading: boolean = true;
  sources: any;

  vertical_scrollbar: boolean = false;
  fileUrl = environment.apiFileUrl;

  ngOnInit(): void {
    const table = document.getElementById("widget-table") as HTMLElement;

    if (!this.rowClick) {
      this.showHoverBg = false;
    }
  }

  objectKeyValue(prop: string | undefined) {
    return prop as string;
  }

  /** Position of `value` in the column's statuses; -1 when it is not listed (the template then falls back to muted). */
  statusIndex(index: number, value: any) {
    const column = this.dataColumns[index];
    if (this.isArray(column.statuses)) {
      return (column.statuses as number[]).findIndex(
        (status_id: number) => status_id === value
      );
    } else {
      return 0;
    }
  }
  clickedRow(data: any) {
    this.onRowClick.emit(data);
  }

  isArray(key: any) {
    return Array.isArray(key);
  }

  onTableChange(event: Event) {
    this.tableChange.emit(event);
  }
  onClick() {
    this.onButtonClick.emit(true);
  }
}
